import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles(() => ({
  titleBar: {
    background:
      'linear-gradient(to bottom, rgba(0,0,0,0.7) 0%, ' +
      'rgba(0,0,0,0.5) 70%, rgba(0,0,0,0) 100%)',
    display: 'flex',
    alignItems: 'end',
    justifyContent: 'space-between',
    flexDirection: 'row'
  },
  publishIcon: {
    color: 'white',
    fontSize: 20
  },
  trashIcon: {
    color: 'red',
    fontSize: 20
  },
  progressArea: {
    flex: 1,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    justifyItems: 'center',
    flexDirection: 'column'
  }
}))

export default useStyles
